/* global jQuery */
import plugin from "@core/plugins/lib";
import debug from "debug";

const ELEMENT_SELECTOR = "[data-compare-pane]";
const PLUGIN_NAME = "comparePane";
const log = debug(PLUGIN_NAME);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

// https://github.com/mattdesl/eases/blob/master/sine-in-out.js
function sineInOut(t) {
	return -0.5 * (Math.cos(Math.PI*t) - 1);
}

// https://vanillajstoolkit.com/helpers/debounce/
function debounce(fn) {
	// Setup a timer
	var timeout;

	// Return a function to run debounced
	return function () {

		// Setup the arguments
		var context = this;
		var args = arguments;

		// If there's a timer, cancel it
		if (timeout) {
			window.cancelAnimationFrame(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = window.requestAnimationFrame(function () {
			fn.apply(context, args);
		});
	};
};

class ComparePane {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.scrollLeft = 0;
		this.scrollWidth = 0;
		this.clientWidth = 0;
		this.stepWidth = 0;

		this.pane = this.element.querySelector(
			this.options.paneSelector
		);

		this.stepWidthElement = this.element.querySelector(
			this.options.stepWidthElementSelector
		);

		this.buttonLeft = this.element.querySelector(
			this.options.buttonLeftSelector
		);

		this.buttonRight = this.element.querySelector(
			this.options.buttonRightSelector
		);

		this.debouncedUpdate = debounce(this.update);

		this.init();
		this.watch();

		log("ready", this, this.element);
	}

	init() {
		this.update();
	}

	watch() {
		log("watching");

		window.addEventListener('resize', this.debouncedUpdate.bind(this));
		this.pane.addEventListener('scroll', this.debouncedUpdate.bind(this));
		this.buttonLeft.addEventListener('click', this.scrollPaneLeft.bind(this));
		this.buttonRight.addEventListener('click', this.scrollPaneRight.bind(this));
	}

	measure() {
		this.scrollLeft = this.pane.scrollLeft || 0;
		this.scrollWidth = this.pane.scrollWidth;
		this.clientWidth = this.pane.clientWidth;
		this.stepWidth = this.stepWidthElement.clientWidth;
	}

	update() {
		this.measure();
		this.updateDisabled(this.buttonLeft, this.isLeftMax.bind(this));
		this.updateDisabled(this.buttonRight, this.isRightMax.bind(this));
		this.updateFocusable(this.pane, this.isScrollable.bind(this));
	}

	updateDisabled(button, condition) {
		button.disabled = !!condition();
	}

	updateFocusable(pane, condition) {
		pane.tabindex = !!condition() ? '0' : '-1';
	}

	isLeftMax() {
		return this.scrollLeft < this.options.scrollEdgeThreshold;
	}

	isRightMax() {
		return (
			this.scrollWidth - this.clientWidth - this.scrollLeft <
			this.options.scrollEdgeThreshold
		);
	}

	isScrollable() {
		return !this.isLeftMax() || !this.isRightMax();
	}

	isFocusable() {
		return this.isScrollable() ? '0' : '-1';
	}

	smoothScroll(param, timestamp) {
		const {
			startTime = timestamp,
			startPos,
			direction,
			duration
		} = param;

		const scrollStep = this.stepWidth;

		const timeElapsed = timestamp - startTime;
		const easeElapsed = timeElapsed / duration;
		const targetScrollDist = scrollStep * direction;

		this.pane.scrollLeft = startPos + targetScrollDist * sineInOut(easeElapsed);

		if (timeElapsed < duration) {
			window.requestAnimationFrame(
				this.smoothScroll.bind(this, {
					startPos: startPos,
					direction: direction,
					duration: duration,
					startTime: startTime
				})
			);
		}
	}

	scrollPaneLeft() {
		const startPos = this.pane.scrollLeft;
		const scroller = this.smoothScroll.bind(this, {
			startPos: startPos,
			direction: -1,
			duration: this.options.scrollDuration
		});
		window.requestAnimationFrame(scroller);
	}

	scrollPaneRight() {
		const startPos = this.pane.scrollLeft;
		const scroller = this.smoothScroll.bind(this, {
			startPos: startPos,
			direction: 1,
			duration: this.options.scrollDuration
		});
		window.requestAnimationFrame(scroller);
	}
}

ComparePane.DEFAULTS = {
	scrollEdgeThreshold: 5,
	scrollDuration: 500
};

plugin(PLUGIN_NAME, ComparePane);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});


// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/components/cover-selector/compare-pane.js